
export default [
	{
		modulo: 8,
		privilegio: 44,
		routerName: 'aeronave',
		routerPath: '/aeronave',
		componentName: 'Aeronave',
		componentPath: 'modules/layout/admin-geral/aeronave/main'
	},
	{
		modulo: 8,
		privilegio: 245,
		routerName: 'alocacao',
		routerPath: '/alocacao',
		componentName: 'Alocacao',
		componentPath: 'modules/layout/admin-geral/alocacao/main'
	},
	{
		modulo: 8,
		privilegio: 245,
		routerName: 'alocacao-cadastro',
		routerPath: '/cadastro-alocacao/cadastro',
		componentName: 'AlocacaoCadastro',
		componentPath: 'modules/layout/admin-geral/alocacao/cadastro'
	},
	{
		modulo: 8,
		privilegio: 245,
		props: true,
		routerName: 'alocacao-editar',
		routerPath: '/alocacao/editar/:id',
		componentName: 'AlocacaoCadastro',
		componentPath: 'modules/layout/admin-geral/alocacao/cadastro'
	},
	{
		modulo: 8,
		privilegio: 228,
		routerName: 'veiculos',
		routerPath: '/veiculos',
		componentName: 'Veiculos',
		componentPath: 'modules/layout/admin-geral/veiculos/main'
	},
	{
		modulo: 8,
		privilegio: 228,
		routerName: 'veiculos-cadastro',
		routerPath: '/cadastro-veiculos/cadastro',
		componentName: 'VeiculosCadastro',
		componentPath: 'modules/layout/admin-geral/veiculos/cadastro'
	},
	{
		modulo: 8,
		privilegio: 228,
		props: true,
		routerName: 'veiculos-editar',
		routerPath: '/veiculos/editar/:id',
		componentName: 'VeiculosCadastro',
		componentPath: 'modules/layout/admin-geral/veiculos/cadastro'
	},
	{
		modulo: 8,
		privilegio: 103,
		routerName: 'cadastro-motor',
		routerPath: '/cadastro-motor',
		componentName: 'CadastroMotor',
		componentPath: 'modules/layout/admin-geral/motor/main'
	},
	{
		modulo: 8,
		privilegio: 113,
		routerName: 'cadastro-comissaria',
		routerPath: '/cadastro-comissaria',
		componentName: 'CadastroComissaria',
		componentPath: 'modules/layout/admin-geral/comissaria/main'
	},
	{
		modulo: 8,
		privilegio: 114,
		routerName: 'cadastro-fornecedor',
		routerPath: '/cadastro-fornecedor',
		componentName: 'CadastroFornecedor',
		componentPath: 'modules/layout/admin-geral/fornecedor/main'
	},
	{
		modulo: 8,
		privilegio: 247,
		routerName: 'unidade-armazenamento',
		routerPath: '/unidade-armazenamento',
		componentName: 'UnidadeArmazenamento',
		componentPath: 'modules/layout/admin-geral/unidade-armazenamento/main'
	},
	{
		modulo: 8,
		privilegio: 247,
		routerName: 'unidade-armazenamento-cadastro',
		routerPath: '/unidade-armazenamento/cadastro',
		componentName: 'UnidadeArmazenamento',
		componentPath: 'modules/layout/admin-geral/unidade-armazenamento/cadastro'
	},
	{
		modulo: 8,
		privilegio: 247,
		props: true,
		routerName: 'unidade-armazenamento-editar',
		routerPath: '/unidade-armazenamento/editar/:id',
		componentName: 'UnidadeArmazenamento',
		componentPath: 'modules/layout/admin-geral/unidade-armazenamento/cadastro'
	},
	{
		modulo: 8,
		privilegio: 261,
		routerName: 'tipo-armazenamento',
		routerPath: '/tipo-armazenamento',
		componentName: 'TipoArmazenamento',
		componentPath: 'modules/layout/admin-geral/tipo-armazenamento/main'
	},
	{
		modulo: 8,
		privilegio: 261,
		routerName: 'tipo-armazenamento-cadastro',
		routerPath: '/tipo-armazenamento/cadastro',
		componentName: 'TipoArmazenamentoCadastro',
		componentPath: 'modules/layout/admin-geral/tipo-armazenamento/cadastro'
	},
	{
		modulo: 8,
		privilegio: 261,
		props: true,
		routerName: 'tipo-armazenamento-editar',
		routerPath: '/tipo-armazenamento/editar/:id',
		componentName: 'TipoArmazenamentoEditar',
		componentPath: 'modules/layout/admin-geral/tipo-armazenamento/cadastro'
	},
	{
		modulo: 8,
		privilegio: 46,
		routerName: 'cadastro-de-cargo',
		routerPath: '/cadastro-de-cargo',
		componentName: 'Cargo',
		componentPath: 'modules/layout/admin-geral/cargo/main'
	},
	{
		modulo: 8,
		privilegio: 47,
		routerName: 'cadastro-de-posto',
		routerPath: '/cadastro-de-posto',
		componentName: 'Posto',
		componentPath: 'modules/layout/admin-geral/posto/main'
	},
	{
		modulo: 8,
		privilegio: 49,
		routerName: 'cadastro-de-orgao',
		routerPath: '/cadastro-de-orgao',
		componentName: 'Orgao',
		componentPath: 'modules/layout/admin-geral/orgao/main'
	},
	{
		modulo: 8,
		privilegio: 50,
		routerName: 'cadastro-tipo-acao',
		routerPath: '/cadastro-tipo-acao',
		componentName: 'Status',
		componentPath: 'modules/layout/admin-geral/tipo-acao/main'
	},
	{
		modulo: 8,
		privilegio: 51,
		routerName: 'cadastro-tipo-afastamento',
		routerPath: '/cadastro-tipo-afastamento',
		componentName: 'TipoAfastamento',
		componentPath: 'modules/layout/admin-geral/tipo-afastamento/main'
	},
	{
		modulo: 8,
		privilegio: 52,
		routerName: 'cadastro-tipo-guarnicao',
		routerPath: '/cadastro-tipo-guarnicao',
		componentName: 'TipoGuarnicao',
		componentPath: 'modules/layout/admin-geral/tipo-guarnicao/main'
	},
	{
		modulo: 8,
		privilegio: 53,
		routerName: 'cadastro-tipo-missao',
		routerPath: '/cadastro-tipo-missao',
		componentName: 'TipoMissao',
		componentPath: 'modules/layout/admin-geral/tipo-missao/main'
	},
	{
		modulo: 8,
		privilegio: 54,
		routerName: 'cadastro-tipo-natureza',
		routerPath: '/cadastro-tipo-natureza',
		componentName: 'TipoNatureza',
		componentPath: 'modules/layout/admin-geral/tipo-natureza/main'
	},
	{
		modulo: 8,
		privilegio: 55,
		routerName: 'cadastro-tipo-ocorrencia',
		routerPath: '/cadastro-tipo-ocorrencia',
		componentName: 'TipoOcorrencia',
		componentPath: 'modules/layout/admin-geral/tipo-ocorrencia/main'
	},
	{
		modulo: 8,
		privilegio: 56,
		routerName: 'cadastro-tipo-prioridade',
		routerPath: '/cadastro-tipo-prioridade',
		componentName: 'TipoPrioridade',
		componentPath: 'modules/layout/admin-geral/tipo-prioridade/main'
	},
	{
		modulo: 8,
		privilegio: 70,
		routerName: 'cadastro-rotaer',
		routerPath: '/cadastro-rotaer',
		componentName: 'Rotaer',
		componentPath: 'modules/layout/admin-geral/rotaer/main'
	},
	{
		modulo: 8,
		privilegio: 73,
		routerName: 'cadastro-departamento',
		routerPath: '/cadastro-departamento',
		componentName: 'Departamento',
		componentPath: 'modules/layout/admin-geral/departamento/main'
	},
	{
		modulo: 8,
		privilegio: 226,
		routerName: 'grupo-passageiros',
		routerPath: '/grupo-passageiros',
		componentName: 'CadastroGrupoPassageirosForm',
		componentPath: 'modules/layout/admin-geral/cadastro-grupo-passageiros/main'
	},
	{
		modulo: 8,
		privilegio: 226,
		routerName: 'grupo-passageiros-cadastro',
		routerPath: '/grupo-passageiros/cadastro',
		componentName: 'CadastroGrupoPassageirosForm',
		componentPath:
			'modules/layout/admin-geral/cadastro-grupo-passageiros/form/main'
	},
	{
		modulo: 8,
		privilegio: 226,
		routerName: 'grupo-passageiros-editar',
		routerPath: '/grupo-passageiros/editar/:id',
		props: true,
		componentName: 'CadastroGrupoPassageiros',
		componentPath:
			'modules/layout/admin-geral/cadastro-grupo-passageiros/form/main'
	},
	{
		modulo: 8,
		privilegio: 225,
		routerName: 'passageiros',
		routerPath: '/passageiros',
		componentName: 'CadastroPassageiros',
		componentPath: 'modules/layout/admin-geral/cadastro-passageiros/main'
	},
	{
		modulo: 8,
		privilegio: 225,
		routerName: 'passageiros-cadastro',
		routerPath: '/passageiros/cadastro',
		componentName: 'CadastroPassageirosForm',
		componentPath: 'modules/layout/admin-geral/cadastro-passageiros/form/main'
	},
	{
		modulo: 8,
		privilegio: 225,
		routerName: 'passageiros-editar',
		routerPath: '/passageiros/editar/:id',
		props: true,
		componentName: 'CadastroPassageirosForm',
		componentPath: 'modules/layout/admin-geral/cadastro-passageiros/form/main'
	},
	{
		modulo: 8,
		privilegio: 23,
		routerName: 'funcoes-bordo',
		routerPath: '/funcoes',
		componentName: 'FuncoesDeBordo',
		componentPath: 'modules/layout/admin-geral/funcoes-de-bordo/main'
	},
	{
		modulo: 8,
		privilegio: 79,
		routerName: 'contexto-operativo',
		routerPath: '/contexto-operativo',
		componentName: 'ContextoOperativo',
		componentPath: 'modules/layout/admin-geral/contexto-operativo/main'
	},
	{
		modulo: 8,
		privilegio: 222,
		routerName: 'descricao-ordem-missao',
		routerPath: '/descricao-ordem-missao',
		componentName: 'DescricaoOrdemMissao',
		componentPath: 'modules/layout/admin-geral/descricao-ordem-missao/main'
	},
	{
		modulo: 8,
		privilegio: 80,
		routerName: 'orgaos-apoiados',
		routerPath: '/orgaos-apoiados',
		componentName: 'OrgaosApoiados',
		componentPath: 'modules/layout/admin-geral/orgaos-apoiados/main'
	},
	{
		modulo: 8,
		privilegio: 221,
		routerName: 'orgaos-apoiados-unidade',
		routerPath: '/orgaos-apoiados-unidade',
		componentName: 'OrgaosApoiadosUnidade',
		componentPath: 'modules/layout/admin-geral/orgaos-apoiados-unidade/main'
	},
	{
		modulo: 8,
		privilegio: 78,
		routerName: 'classificacao',
		routerPath: '/classificacao',
		componentName: 'Classificacao',
		componentPath: 'modules/layout/admin-geral/classificacao/main'
	},
	{
		modulo: 8,
		privilegio: 78,
		routerName: 'subclassificacao',
		routerPath: '/subclassificacao',
		componentName: 'SubClassificacao',
		componentPath: 'modules/layout/admin-geral/subclassificacao/main'
	},
	{
		modulo: 8,
		privilegio: 116,
		routerName: 'base-operacional',
		routerPath: '/base-operacional',
		componentName: 'BaseOperacional',
		componentPath: 'modules/layout/admin-geral/base-operacional/main'
	},
	{
		modulo: 8,
		privilegio: 123,
		routerName: 'codigo-pnapa',
		routerPath: '/codigo-pnapa',
		componentName: 'CodigoPnapa',
		componentPath: 'modules/layout/admin-geral/codigo-pnapa/main'
	},
	{
		modulo: 8,
		privilegio: 152,
		routerName: 'pontos-interesse',
		routerPath: '/pontos-interesse',
		componentName: 'PontosInteresse',
		componentPath: 'modules/layout/admin-geral/pontos-interesse/main'
	},
	{
		modulo: 8,
		privilegio: 125,
		routerName: 'plano-fundo',
		routerPath: '/plano-fundo',
		componentName: 'PlanoDeFundo',
		componentPath: 'modules/layout/admin-geral/plano-fundo/main'
	},
	{
		modulo: 8,
		privilegio: 121,
		routerName: 'termo-de-uso',
		routerPath: '/termo-de-uso',
		componentName: 'TermoDeUso',
		componentPath: 'modules/layout/admin-geral/termo-de-uso/main'
	},
	{
		modulo: 8,
		privilegio: 126,
		routerName: 'metas-indicadores',
		routerPath: '/metas-indicadores',
		componentName: 'MetasIndicadores',
		componentPath: 'modules/layout/admin-geral/metas-indicadores/main'
	},
	{
		modulo: 8,
		privilegio: 128,
		routerName: 'unidade-conservacao',
		routerPath: '/unidade-conservacao',
		componentName: 'UnidadeConservacao',
		componentPath: 'modules/layout/admin-geral/unidade-conservacao/main'
	},
	{
		modulo: 8,
		privilegio: 137,
		routerName: 'cadastro-tipo-atividade',
		routerPath: '/cadastro-tipo-atividade',
		componentName: 'CadastroAtividade',
		componentPath: 'modules/layout/admin-geral/tipo-atividade/main'
	},
	{
		modulo: 8,
		privilegio: 126,
		routerName: 'configuracao-aeronave',
		routerPath: '/configuracao-aeronave',
		componentName: 'CadastroEquipamentosAeronave',
		componentPath: 'modules/layout/admin-geral/configuracao-aeronave/main'
	},
	{
		modulo: 8,
		privilegio: 172,
		routerName: 'cadastro-licenca',
		routerPath: '/cadastro-licenca',
		componentName: 'CadastroLicenca',
		componentPath: 'modules/layout/admin-geral/licenca/main'
	},
	{
		modulo: 8,
		privilegio: 183,
		routerName: 'cadastro-apu',
		routerPath: '/cadastro-apu',
		componentName: 'CadastroAPU',
		componentPath: 'modules/layout/admin-geral/motor-apu/main'
	},
	{
		modulo: 8,
		privilegio: 195,
		routerName: 'tipo-embalagem',
		routerPath: '/tipo-embalagem',
		componentName: 'TipoEmbalagem',
		componentPath: 'modules/layout/admin-geral/tipo-embalagem/main'
	},
	{
		modulo: 8,
		privilegio: 229,
		routerName: 'atencao-especial',
		routerPath: '/atencao-especial',
		componentName: 'AtencaoEspecial',
		componentPath: 'modules/layout/admin-geral/atencao-especial/main'
	},
	{
		modulo: 8,
		privilegio: 205,
		routerName: 'cadastro-de-eventos',
		routerPath: '/cadastro-de-eventos',
		componentName: 'CadastroEventos',
		componentPath: 'modules/layout/admin-geral/eventos/main'
	},
	{
		modulo: 8,
		privilegio: 192,
		routerName: 'combustiveis',
		routerPath: '/combustiveis',
		componentName: 'ComprovanteAbastecimento',
		componentPath: 'modules/layout/admin-geral/combustiveis/main'
	},
	{
		modulo: 8,
		privilegio: 213,
		routerName: 'layers',
		routerPath: '/layers',
		componentName: 'Layer',
		componentPath: 'modules/layout/admin-geral/layer/main'
	},
	{
		modulo: 8,
		privilegio: 213,
		routerName: 'layers-register',
		routerPath: '/layers-register',
		componentName: 'LayerForm',
		componentPath: 'modules/layout/admin-geral/layer/form'
	},
	{
		modulo: 8,
		privilegio: 213,
		routerName: 'layers-edit',
		routerPath: '/layers-edit/:id',
		props: true,
		componentName: 'LayerForm',
		componentPath: 'modules/layout/admin-geral/layer/form'
	},
	{
		modulo: 8,
		privilegio: 210,
		routerName: 'unidade-medida',
		routerPath: '/unidade-medida',
		componentName: 'UnidadeMedida',
		componentPath: 'modules/layout/admin-geral/unidade-medida/main'
	},
	{
		modulo: 8,
		privilegio: 0,
		routerName: 'unidade-orcamentaria',
		routerPath: '/unidade-orcamentaria',
		componentName: 'UnidadeOrcamentaria',
		componentPath: 'modules/layout/admin-geral/unidade-orcamentaria/main'
	},
	{
		modulo: 8,
		privilegio: 0,
		routerName: 'unidade-orcamentaria-cadastro',
		routerPath: '/unidade-orcamentaria/cadastro',
		componentName: 'UnidadeOrcamentariaCadastro',
		componentPath: 'modules/layout/admin-geral/unidade-orcamentaria/form'
	},
	{
		modulo: 8,
		privilegio: 0,
		props: true,
		routerName: 'unidade-orcamentaria-editar',
		routerPath: '/unidade-orcamentaria/editar/:id',
		componentName: 'UnidadeOrcamentariaEditar',
		componentPath: 'modules/layout/admin-geral/unidade-orcamentaria/form'
	},
	{
		modulo: 8,
		privilegio: 0,
		props: true,
		routerName: 'cadastro-civ',
		routerPath: '/cadastro-civ',
		componentName: 'CadastroCIV',
		componentPath: 'modules/layout/admin-geral/cadastro-civ/main'
	},
	{
		modulo: 8,
		privilegio: 0,
		props: true,
		routerName: 'cadastro-funcao-tripulante',
		routerPath: '/cadastro-funcao-tripulante',
		componentName: 'CadastroFuncaoTripulante',
		componentPath: 'modules/layout/admin-geral/cadastro-funcao-tripulante/main'
	},
	{
		modulo: 8,
		privilegio: 0,
		routerName: 'habilitacao',
		routerPath: '/habilitacao',
		componentName: 'Habilitacao',
		componentPath: 'modules/layout/admin-geral/habilitacao/main'
	},
	{
		modulo: 30,
		privilegio: 283,
		routerName: 'fiscalizacao-rampa',
		routerPath: '/fiscalizacao-rampa',
		componentName: 'FiscalizacaoRampa',
		componentPath: 'modules/layout/fiscalizacao-rampa/main'
	},
	{
		modulo: 8,
		privilegio: 281,
		routerName: 'parametro',
		routerPath: '/parametro',
		componentName: 'parametro',
		componentPath: 'modules/layout/admin-geral/parametro/main'
	}
]
